export default {
  ko: {
    "학습분석": "학습분석",
    "학습현황": "학습현황",
    "학기별현황": "학기별 현황",
    "기간별현황": "기간별 현황",
    "과목별현황": "과목별 현황",
    "종합활동현황": "종합 활동현황",
    "주차별활동참여율": "주차별 활동 참여율",
    "주차별활동시간": "주차별 활동시간",
    "년도별활동현황": "년도별 활동현황",
    "년도주차별참여율": "년도 주차별 참여율",
    "년도주차별활동시간": "년도 주차별 활동시간",
    "과목별활동현황": "과목별 활동현황",
    "학습자평균": "학습자평균",
    "교과목을선택하세요": "교과목을 선택하세요",
    "과목을선택하세요": "과목을 선택하세요",
    "과목이없습니다": "과목이 없습니다",
    "선택해주세요": "선택해 주세요",
    "{0}년도": "{0}년도",
    "{0}년도{1}": "{0}년도 {1}",
    "{0}주차": "{0}주차",
    "전체": "전체",
    "제출": "제출",
    "참여": "참여",
    "완료": "완료",
    "미완료": "미완료",
    "검색": "검색",
    "적용": "적용",
    "알림": "알림",
    "확인": "확인",
    "분": "분",
    "완료율": "완료율",
    "접속시간(분)": "접속시간(분)",
    "학습자평균(분)": "학습자평균(분)",
    "동영상": "동영상",
    "Live강의": "Live강의",
    "과제": "과제",
    "퀴즈": "퀴즈",
    "간편설문": "간편설문",
    "설문조사": "설문조사",
    "과제상호평가": "과제상호평가",
    "url": "url",
    "게시판": "게시판",
    "파일": "파일",
    "코딩교육": "코딩교육",
    "폴더": "폴더",
    "봄": "봄",
    "여름": "여름",
    "가을": "가을",
    "겨울": "겨울",
    "학습율": "학습율",
    "제출율": "제출율",
    "참여율": "참여율",
    "평균참여율": "평균참여율",
    "전체건수": "전체건수",
    "완료건수": "완료건수",
    "참여건수": "참여건수",
    "제출건수": "제출건수",
  },
  en: {
    "학습분석": "Learning Analysis",
    "학습현황": "학습현황",
    "학기별현황": "학기별 현황",
    "기간별현황": "기간별 현황",
    "과목별현황": "과목별 현황",
    "종합활동현황": "종합 활동현황",
    "주차별활동참여율": "주차별 활동 참여율",
    "주차별활동시간": "주차별 활동시간",
    "년도별활동현황": "년도별 활동현황",
    "년도주차별참여율": "년도 주차별 참여율",
    "년도주차별활동시간": "년도 주차별 활동시간",
    "과목별활동현황": "과목별 활동현황",
    "학습자평균": "학습자평균",
    "교과목을선택하세요": "교과목을 선택하세요",
    "과목을선택하세요": "과목을 선택하세요",
    "과목이없습니다": "과목이 없습니다",
    "선택해주세요": "선택해 주세요",
    "{0}년도": "{0}년도",
    "{0}년도{1}": "{0}년도 {1}",
    "{0}주차": "{0}주차",
    "전체": "전체",
    "제출": "제출",
    "참여": "참여",
    "완료": "완료",
    "미완료": "미완료",
    "검색": "검색",
    "적용": "적용",
    "알림": "알림",
    "확인": "확인",
    "분": "분",
    "완료율": "완료율",
    "접속시간(분)": "접속시간(분)",
    "학습자평균(분)": "학습자평균(분)",
    "동영상": "동영상",
    "Live강의": "Live강의",
    "과제": "과제",
    "퀴즈": "퀴즈",
    "간편설문": "간편설문",
    "설문조사": "설문조사",
    "과제상호평가": "과제상호평가",
    "url": "url",
    "게시판": "게시판",
    "파일": "파일",
    "코딩교육": "코딩교육",
    "폴더": "폴더",
    "봄": "봄",
    "여름": "여름",
    "가을": "가을",
    "겨울": "겨울",
    "학습율": "학습율",
    "제출율": "제출율",
    "참여율": "참여율",
    "평균참여율": "평균참여율",
    "전체건수": "전체건수",
    "완료건수": "완료건수",
    "참여건수": "참여건수",
    "제출건수": "제출건수",
  }
}
